import React from "react";

const NotFound = ({ errorMessage }) => (
  <div>{errorMessage || "Organization not found."}</div>
);

export default NotFound;
